import type { UnknownAction } from '@reduxjs/toolkit';
import { createAction } from '@reduxjs/toolkit';

interface MetaDataAction extends UnknownAction {
  payload: string;
  type: MetaDataActionType;
}

export enum MetaDataActionType {
  ADD_ERROR = 'ADD_ERROR',
  REMOVE_ERROR = 'REMOVE_ERROR',
}

export const addError = createAction(MetaDataActionType.ADD_ERROR);
export const removeError = createAction(MetaDataActionType.REMOVE_ERROR);

export type { MetaDataAction };
